<template>
  <div data-testid="customer-import-summary">
    <div v-if="errorCount">
      <div class="card">
        <div class="card-body">
          <h2 class="mt-3 mb-2">
            <span class="text-primary">{{ errorCount }}</span> customer{{
              errorCount > 1 ? 's were' : ' was'
            }}
            unable to be imported.
          </h2>
          <p class="mb-4 text-muted">Here is a list of those that didn't work out.</p>
          <p
            v-if="truncated"
            class="mb-4 text-muted"
            data-testid="customer-import-summary-truncated"
          >
            Showing the first {{ failedRows.length }} of {{ errorCount }} rows that could not be
            imported.
          </p>

          <div class="col-12">
            <table class="table table-nowrap">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Reason</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="failedRow in failedRows"
                  :key="failedRow.row"
                  data-testid="customer-import-summary-row"
                >
                  <th scope="row">{{ failedRow.row }}</th>
                  <td>{{ failedRow.name }}</td>
                  <td>{{ failedRow.email }}</td>
                  <td>{{ failedRow.phone }}</td>
                  <td class="text-danger">{{ failedRow.reason }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <button
      @click="done"
      class="btn btn-primary btn-lg mr-3"
      data-testid="customer-import-summary-continue"
    >
      Continue
    </button>
  </div>
</template>

<script>
export default {
  name: 'CustomerImportSummary',
  props: {
    failedRows: { type: Array, default: () => [] },
    errorCount: { type: Number, default: 0 },
    truncated: { type: Boolean, default: false }
  },
  methods: {
    done() {
      this.$emit('done')
    }
  }
}
</script>

<style scoped lang="scss"></style>
